<div class="preloader text-align-center" [ngClass]="customClass">
  <div class="transparent"></div>
  <img class="loader" [src]="color ? coloredLoaderUrl : grayLoaderUrl" />
</div>
